import { SET_CURRENT_FORMCONFIG } from "redux/types";

const setCurrentFormConfig = (payload) => {
    return { type: SET_CURRENT_FORMCONFIG, payload };
};

export { setCurrentFormConfig };
